var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMContenedorPagina(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eccb6;}.cls-2{fill:#329be6;}.cls-3{fill:#0b5c96;}.cls-4{fill:#fff;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_contenedor_pagina"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contenedor_de_p\\xE1gina",
    "data-name": "Contenedor de p\\xE1gina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.16,22.84.28,32.72a.4.4,0,0,0,0,.56l9.88,9.88A25.05,25.05,0,0,1,10.16,22.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.16,10.16,33.28.28a.4.4,0,0,0-.56,0l-9.88,9.88a25,25,0,0,1,20.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.84,55.84l9.88,9.88a.4.4,0,0,0,.56,0l9.88-9.88a25,25,0,0,1-20.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.72,32.72l-9.88-9.88a25.05,25.05,0,0,1,0,20.32l9.88-9.88A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.32,50.68a25.12,25.12,0,0,0,7.52,5.16L10.16,43.16A25.12,25.12,0,0,0,15.32,50.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.68,50.68a25.12,25.12,0,0,0,5.16-7.52L43.16,55.84A25.12,25.12,0,0,0,50.68,50.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.68,15.32a25.12,25.12,0,0,0-7.52-5.16L55.84,22.84A25.12,25.12,0,0,0,50.68,15.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.32,15.32a25.12,25.12,0,0,0-5.16,7.52L22.84,10.16A25.12,25.12,0,0,0,15.32,15.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.84,22.84,43.16,10.16a25,25,0,0,0-20.32,0L10.16,22.84a25.05,25.05,0,0,0,0,20.32L22.84,55.84a25,25,0,0,0,20.32,0L55.84,43.16A25.05,25.05,0,0,0,55.84,22.84Zm-24,17a26.06,26.06,0,0,0-8.9,2,41.2,41.2,0,0,1-.87-7.54h9.76Zm0-8.09H22.07A40.73,40.73,0,0,1,23,23.89a26,26,0,0,0,8.8,1.93Zm0-21V23.32a23.49,23.49,0,0,1-8.14-1.88,27.45,27.45,0,0,1,2-4.93C27.42,13.28,29.6,11.23,31.8,10.67ZM17.09,17.09A22.32,22.32,0,0,1,26,11.62a24.17,24.17,0,0,0-4.62,8.7A23.9,23.9,0,0,1,17,17.15ZM15.38,19a26.15,26.15,0,0,0,5.33,3.77,43.05,43.05,0,0,0-1.15,8.93l-9,0A22.33,22.33,0,0,1,15.38,19ZM10.57,34.25l9,0a43.35,43.35,0,0,0,1.07,8.64,26.53,26.53,0,0,0-5.41,3.88A22.33,22.33,0,0,1,10.57,34.25Zm6.52,14.66c-.08-.08-.15-.18-.24-.26a23.42,23.42,0,0,1,4.45-3.28,24.54,24.54,0,0,0,4.72,9A22.32,22.32,0,0,1,17.09,48.91Zm8.59.58a27.11,27.11,0,0,1-2.11-5.26,23.69,23.69,0,0,1,8.27-1.92l0,13C29.64,54.81,27.44,52.75,25.68,49.49ZM55.44,31.68h-9a42.75,42.75,0,0,0-1.15-8.89A26.15,26.15,0,0,0,50.62,19,22.3,22.3,0,0,1,55.44,31.68ZM48.91,17.09l.06.06a23.5,23.5,0,0,1-4.37,3.17A24.17,24.17,0,0,0,40,11.62,22.32,22.32,0,0,1,48.91,17.09ZM34.3,10.7c2.16.59,4.3,2.62,6,5.81a27.45,27.45,0,0,1,2,4.93,23.5,23.5,0,0,1-8,1.87Zm0,15.12A26.23,26.23,0,0,0,43,23.89a41.21,41.21,0,0,1,1,7.81h-9.6Zm0,8.39h9.6a41.53,41.53,0,0,1-.87,7.57,26.11,26.11,0,0,0-8.72-2Zm0,8.11a23.7,23.7,0,0,1,8.09,1.91,27.11,27.11,0,0,1-2.11,5.26c-1.7,3.15-3.81,5.17-6,5.79m14.55-6.37A22.32,22.32,0,0,1,40,54.38a24.54,24.54,0,0,0,4.72-9,23.42,23.42,0,0,1,4.45,3.28C49.06,48.73,49,48.83,48.91,48.91Zm-3.54-6a43.85,43.85,0,0,0,1.08-8.69h9a22.3,22.3,0,0,1-4.66,12.58A25.79,25.79,0,0,0,45.37,42.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.78,46.76a25.79,25.79,0,0,0-5.41-3.88,43.85,43.85,0,0,0,1.08-8.69h9A22.3,22.3,0,0,1,50.78,46.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.38,19a26.15,26.15,0,0,0,5.33,3.77,43.05,43.05,0,0,0-1.15,8.93l-9,0A22.33,22.33,0,0,1,15.38,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.44,31.69a42.75,42.75,0,0,0-1.15-8.89A26.15,26.15,0,0,0,50.62,19a22.3,22.3,0,0,1,4.82,12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.93,31.7h-9.6V25.82A26.23,26.23,0,0,0,43,23.89,41.21,41.21,0,0,1,43.93,31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.31,23.31V10.7c2.16.59,4.3,2.62,6,5.81a27.45,27.45,0,0,1,2,4.93A23.5,23.5,0,0,1,34.31,23.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.8,10.67V23.32a23.49,23.49,0,0,1-8.14-1.88,27.45,27.45,0,0,1,2-4.93C27.42,13.28,29.6,11.23,31.8,10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.82,25.82v5.9H22.07A40.73,40.73,0,0,1,23,23.89,26,26,0,0,0,31.82,25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.56,34.23a43.35,43.35,0,0,0,1.07,8.64,26.53,26.53,0,0,0-5.41,3.88,22.33,22.33,0,0,1-4.65-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.07,34.23h9.76v5.59a26.06,26.06,0,0,0-8.9,2A41.2,41.2,0,0,1,22.07,34.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.84,42.31l0,13c-2.22-.54-4.42-2.6-6.18-5.86a27.11,27.11,0,0,1-2.11-5.26A23.69,23.69,0,0,1,31.84,42.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.36,55.28l0-13a23.7,23.7,0,0,1,8.09,1.91,27.11,27.11,0,0,1-2.11,5.26C38.62,52.64,36.51,54.66,34.36,55.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.34,39.81v-5.6h9.6a41.53,41.53,0,0,1-.87,7.57A26.11,26.11,0,0,0,34.34,39.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49,17.15a23.5,23.5,0,0,1-4.37,3.17A24.17,24.17,0,0,0,40,11.62a22.32,22.32,0,0,1,8.93,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26,11.62a24.17,24.17,0,0,0-4.62,8.7A23.9,23.9,0,0,1,17,17.15l.05-.06A22.32,22.32,0,0,1,26,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.85,48.65a23.42,23.42,0,0,1,4.45-3.28,24.54,24.54,0,0,0,4.72,9,22.32,22.32,0,0,1-8.93-5.47C17,48.83,16.94,48.73,16.85,48.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40,54.38a24.54,24.54,0,0,0,4.72-9,23.42,23.42,0,0,1,4.45,3.28c-.09.08-.16.18-.24.26A22.32,22.32,0,0,1,40,54.38Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMContenedorPagina);
export default __webpack_public_path__ + "static/media/m_contenedor_pagina.56302bdbd04f5bfebd03d5eaaef2916b.svg";
export { ForwardRef as ReactComponent };